import React from "react";
import { Button, Text } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

/**
 * CustomTooltip - A reusable component for tooltips with dynamic text and clickable links
 *
 * @param {Object} props
 * @param {string} props.messageKey - The appstr key for the tooltip message
 * @param {Object} props.replaceDict - Dictionary of replacements for dynamic text
 * @param {Object} props.formatConfig - Configuration for formatting dynamic text (e.g., clickable links)
 * @param {string} props.position - Tooltip position (default: "right-start")
 * @param {number} props.delay - Tooltip delay in ms (default: 100)
 * @param {Object} props.buttonProps - Additional props to pass to the Button component
 *
 * Example usage:
 * <CustomTooltip
 *   messageKey="Cost band help"
 *   replaceDict={{ "Help Center": appstr("Help Center") }}
 *   formatConfig={{
 *     "Help Center": {
 *       type: "custom",
 *       onClick: () => window.open("https://example.com", "_blank"),
 *       style: {
 *         color: "#87CEEB",
 *         textDecoration: "underline",
 *         cursor: "pointer"
 *       }
 *     }
 *   }}
 * />
 */
export const CustomTooltip = ({
  messageKey,
  replaceDict = {},
  formatConfig = {},
  position = "right-start",
  delay = 100,
  buttonProps = {}
}) => {
  const template = appstr(messageKey);

  return (
    <Button
      tooltipProps={{
        content: (
          <span className="ocn-tooltip-default-content">
            <Text
              size="xsmall"
              colorModifier="white"
              dynamic={{
                template,
                replaceDict,
                formatConfig
              }}
            >
              {appstr(messageKey, replaceDict)}
            </Text>
          </span>
        ),
        position,
        delay
      }}
      modifier="tertiary"
      iconOnly={true}
      iconProps={{ name: "circle-info" }}
      {...buttonProps}
    />
  );
};

// Common format configurations for reuse
export const TOOLTIP_FORMATS = {
  helpCenterLink: url => ({
    "Help Center": {
      type: "custom",
      onClick: () => window.open(url, "_blank"),
      style: {
        color: "#87CEEB",
        textDecoration: "underline",
        cursor: "pointer"
      }
    }
  }),

  boldLink: (key, url) => ({
    [key]: {
      type: "custom",
      onClick: () => window.open(url, "_blank"),
      style: {
        fontWeight: "bold",
        color: "#87CEEB",
        textDecoration: "underline",
        cursor: "pointer"
      }
    }
  })
};
